import * as React from 'react';

const AccessoriesEcommContext = /*#__PURE__*/ React.createContext(undefined);
const MAX_ORDERABLE_QUANTITY = 5;
const AccessoriesEcommProvider = ({ children , maxOrderableQuantity  })=>{
    const [quantity1, setQuantityInternal] = React.useState(1);
    const setQuantity = React.useCallback((quantity)=>{
        setQuantityInternal(Math.max(1, quantity));
    }, []);
    const value = React.useMemo(()=>({
            quantity: quantity1,
            setQuantity,
            maxOrderableQuantity: maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : MAX_ORDERABLE_QUANTITY
        })
    , [
        maxOrderableQuantity,
        quantity1,
        setQuantity
    ]);
    return /*#__PURE__*/ React.createElement(AccessoriesEcommContext.Provider, {
        value: value
    }, children);
};
const useAccessoriesEcommContext = ()=>{
    const context = React.useContext(AccessoriesEcommContext);
    if (!context) {
        throw new Error('useAccessoriesEcommContext must be used within a AccessoriesEcommProvider');
    }
    return context;
};

export { AccessoriesEcommProvider, useAccessoriesEcommContext };
//# sourceMappingURL=AccessoriesEcommContext.js.map
